const StatisticIcon = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M22.5 17.4H22.275V6.4875C22.275 5.625 21.5625 4.875 20.6625 4.875H18.6375C17.775 4.875 17.025 5.5875 17.025 6.4875V17.4H14.625V8.5875C14.625 7.725 13.9125 6.975 13.0125 6.975H10.9875C10.125 6.975 9.37501 7.6875 9.37501 8.5875V17.4H6.93751V11.025C6.93751 10.1625 6.22501 9.4125 5.32501 9.4125H3.30001C2.43751 9.4125 1.68751 10.125 1.68751 11.025V17.4H1.50001C1.05001 17.4 0.637512 17.775 0.637512 18.2625C0.637512 18.75 1.01251 19.125 1.50001 19.125H22.5C22.95 19.125 23.3625 18.75 23.3625 18.2625C23.3625 17.775 22.95 17.4 22.5 17.4ZM3.41251 17.4V11.1375H5.25001V17.4H3.41251ZM11.0625 17.4V8.7H12.9V17.4H11.0625ZM18.75 17.4V6.6H20.5875V17.4H18.75Z'
        fill='#111928'
      />
    </svg>
  );
};

export default StatisticIcon;
